export default "__VITE_ASSET__UOgBuf6l__"